import { render, staticRenderFns } from "./BeneficialOwnersV2.vue?vue&type=template&id=5da2a4d5&scoped=true&"
import script from "./BeneficialOwnersV2.vue?vue&type=script&lang=js&"
export * from "./BeneficialOwnersV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2a4d5",
  null
  
)

export default component.exports